export const mutations = {
  UPDATE_CLAIMS_SMALL (state, payload) {
    state.claims.small = payload;
  },
  UPDATE_CLAIMS_LARGE (state, payload) {
    state.claims.large = payload;
  },
  UPDATE_CLAIM_LARGE (state, payload) {
    // need to update the claim object within the claims array as well as the individual claim
    const claimInClaims = state.claims.large.find(claim => {
      return claim.ua_icclaimid === payload.ua_icclaimid;
    });

    Object.assign(claimInClaims, payload);

    Object.assign(state.claim, payload);
  },
  UPDATE_CLAIM_SMALL (state, payload) {
    // need to update the claim object within the claims array as well as the individual claim
    const claimInClaims = state.claims.small.find(claim => {
      return claim.ua_icclaimid === payload.ua_icclaimid;
    });

    Object.assign(claimInClaims, payload);

    Object.assign(state.claim, payload);
  },
  RESET_CLAIMS (state) {
    state.claims = {
      large: [],
      small: []
    };
    state.claim = {};
  },
  UPDATE_CLAIM (state, payload) {
    Object.assign(state.claim, payload);
  }
};
